import { Component, OnInit, Input } from '@angular/core';
import { AlertService, AlertSettings } from './alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {
  @Input() alertSettings: AlertSettings;
  @Input() customClass: string;

  constructor(
    public alertService: AlertService
  ) { }

  ngOnInit(): void {}
}
